<template>
  <div class="sidebar-logo-container collapse">
    <div key="collapse" class="sidebar-logo-link">
      <img v-if="logo" :src="logo" class="sidebar-logo">
    </div>
  </div>
</template>

<script>
import store from '../../../../store'
export default {
  name: 'SidebarLogo',
  computed: {
    logo() {
      const staticUrl = window?.serverConfig?.staticUrl || 'yldfiles.geekyum.com'
      const defaultLogo = `https://${staticUrl}/oms/a2526004538e46d196d148df8e38029b.png`
      return store.getters.logoUrl || defaultLogo
    }
  },
  data(){
    return {}
  }
}
</script>

<style lang="scss" scoped>

.sidebar-logo-container {
  position: relative;
  width: 100%;
  height: 50px;
  line-height: 50px;
  text-align: center;
  overflow: hidden;

  & .sidebar-logo-link {
    height: 100%;
    width: 100%;

    & .sidebar-logo {
      width: 100%;
      height: auto;
      vertical-align: middle;
      margin-right: 12px;
    }

    & .sidebar-title {
      display: inline-block;
      margin: 0;
      color: #fff;
      font-weight: 600;
      line-height: 50px;
      font-size: 14px;
      font-family: Avenir, Helvetica Neue, Arial, Helvetica, sans-serif;
      vertical-align: middle;
    }
  }

  &.collapse {
    .sidebar-logo {
      margin-right: 0px;
    }
  }
}
</style>
